/** Nombre comercial y razón social de la cooperativa. */
export const BRAND_SHORT_NAME = 'Coonaltragas';

export const BRAND_LEGAL_NAME = 'Cooperativa Nacional Multiactiva Grupo Asociativo';

export const BRAND_FULL_TITLE = `${BRAND_SHORT_NAME} — ${BRAND_LEGAL_NAME}`;
